import { render, staticRenderFns } from "./GlobalPagination.vue?vue&type=template&id=20e70481&"
import script from "./GlobalPagination.vue?vue&type=script&lang=js&"
export * from "./GlobalPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports